export * from './frameData';
export * from './navigationData';
export { default as utils } from './utils';

// General
export const localeSelector = (state, props) => {
  return props.locale || props.intl.locale;
};
export const propSelector = (state, props) => props;
